import React, { useState } from "react";
import { useLocation } from "react-router-dom";
// import { Link, Navigate } from "react-router-dom";
import {Link as Lnk} from "react-router-dom";
import { Link } from "react-scroll";
// mui
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";

// import { useNavigate } from "react-router-dom";

import "./Navbar.css";

const Navbar = () => {
  // let navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const user = JSON.parse(localStorage.getItem("isIAuthenticated"));

  return (
    <div className="navbar flex">
      <div className="logo">
        <Lnk to="/" className="alogo">
          <h1>interwiu.com</h1>
        </Lnk>
      </div>
      <ul className="nav-list flex">
        {!user?.role && location.pathname === "/" ? (
          <li className="nav-item">
            {/* <Link to="/" className="active">
            Home
          </Link> */}
            <Link
              to="home"
              spy={true}
              smooth={true}
              className="tabs hover-underline-animation"
            >
              Home
            </Link>
            <Link
              to="howItWorks"
              spy={true}
              smooth={true}
              className="tabs hover-underline-animation"
            >
              How it Works
            </Link>
            <Link
              to="features"
              spy={true}
              smooth={true}
              className="tabs hover-underline-animation"
            >
              Features
            </Link>
            <Link
              to="profiles"
              spy={true}
              smooth={true}
              className="tabs hover-underline-animation"
            >
              Profiles
            </Link>
            <Link
              to="pricing"
              spy={true}
              smooth={true}
              className="tabs hover-underline-animation"
            >
              Pricing
            </Link>
            <Link
              to="testimonials"
              spy={true}
              smooth={true}
              className="tabs hover-underline-animation"
            >
              Success Stories
            </Link>
            <Link
              to="faqs"
              spy={true}
              smooth={true}
              className="tabs hover-underline-animation"
            >
              FAQs
            </Link>
          </li>
        ) : null}
      </ul>
      <div className="sidebar flex">
        <button
          className="cust-btn login-btn"
          onClick={() => {
            const loginFunc = document.querySelector(".login-container");
            loginFunc.classList.remove("hide");
          }}
        >
          Log In
        </button>
        <IconButton
          aria-label="more"
          className="navDropdownIcon"
          id="long-button"
          aria-controls={Boolean(anchorEl) ? "long-menu" : undefined}
          aria-expanded={Boolean(anchorEl) ? "true" : undefined}
          aria-haspopup="true"
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          <MenuRoundedIcon />
        </IconButton>
        <Menu
          id="long-menu"
          className="navDropdown"
          MenuListProps={{
            "aria-labelledby": "long-button",
          }}
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
        >
          <MenuItem>
            <Link
              style={{ textDecoration: "none", color: "black" }}
              to="home"
              spy={true}
              smooth={true}
              className="tabs hover-underline-animation"
              onClick={() => setAnchorEl(null)}
            >
              Home
            </Link>
          </MenuItem>
          <MenuItem>
            <Link
              style={{ textDecoration: "none", color: "black" }}
              to="howItWorks"
              spy={true}
              smooth={true}
              className="tabs hover-underline-animation"
              onClick={() => setAnchorEl(null)}
            >
              How it Works
            </Link>
          </MenuItem>
          <MenuItem>
            <Link
              style={{ textDecoration: "none", color: "black" }}
              to="features"
              spy={true}
              smooth={true}
              className="tabs hover-underline-animation"
              onClick={() => setAnchorEl(null)}
            >
              Features
            </Link>
          </MenuItem>
          <MenuItem>
            <Link
              style={{ textDecoration: "none", color: "black" }}
              to="profiles"
              spy={true}
              smooth={true}
              className="tabs hover-underline-animation"
              onClick={() => setAnchorEl(null)}
            >
              Profiles
            </Link>
          </MenuItem>
          <MenuItem>
            <Link
              style={{ textDecoration: "none", color: "black" }}
              to="pricing"
              spy={true}
              smooth={true}
              className="tabs hover-underline-animation"
              onClick={() => setAnchorEl(null)}
            >
              Pricing
            </Link>
          </MenuItem>
          <MenuItem>
            <Link
              style={{ textDecoration: "none", color: "black" }}
              to="testimonials"
              spy={true}
              smooth={true}
              className="tabs hover-underline-animation"
              onClick={() => setAnchorEl(null)}
            >
              Success Stories
            </Link>
          </MenuItem>
          <MenuItem>
            <Link
              style={{ textDecoration: "none", color: "black" }}
              to="faqs"
              spy={true}
              smooth={true}
              className="tabs hover-underline-animation"
              onClick={() => setAnchorEl(null)}
            >
              FAQs
            </Link>
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
};

export default Navbar;
